import React, { ReactNode } from 'react';

export const CUSTOM_ERROR = 'customError' as const;

export type ValidationError = Exclude<keyof ValidityState, 'valid'>;

export type ValidationEventHandler<E extends Element | RadioNodeList> = (event: React.InvalidEvent<E>, errors: ValidationError[], message?: string) => void;

export type CustomErrorMessage = ReactNode | Record<keyof ValidityState, ReactNode>;

export type InputTypes =
  | 'button'
  | 'checkbox'
  | 'color'
  | 'date'
  | 'datetime-local'
  | 'email'
  | 'file'
  | 'hidden'
  | 'image'
  | 'month'
  | 'number'
  | 'password'
  | 'radio'
  | 'range'
  | 'reset'
  | 'search'
  | 'submit'
  | 'tel'
  | 'text'
  | 'time'
  | 'url'
  | 'week'
